import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, OFFER_ANCHOR, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="bg-ink" data-id="element-56" data-mp="c70xva6rjfok">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-57" data-mp="c4fu2fmwmpo6">
        <h2 id="cierre" className="font-display text-[1.5rem] font-extrabold leading-none tracking-tight text-coral sm:text-4xl" data-id="element-58" data-mp="83m7bpl77gwv">
          Una última oportunidad
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-white/90" data-id="element-59" data-mp="h5ln6ekh8ey8">
          Puedes seguir acumulando apuntes, resúmenes y archivos sobre anatomía,
          farmacología, patologías y cuidados de enfermería sin saber qué
          estudiar primero. O puedes comenzar hoy a organizar tu aprendizaje con
          un sistema visual completo.
        </p>
        <p className="mx-auto mt-1.5 max-w-xl font-sub text-sm font-semibold leading-snug text-white" data-id="element-60" data-mp="zx4s4qy2a32w">
          No necesitas memorizar cientos de páginas de golpe.{' '}
          <span className="text-tint" data-id="element-61" data-mp="2h3hoqp2m8y6d">
            Necesitas un método que te ayude a comprender, relacionar y repasar
            cada tema.
          </span>
        </p>

        <Reveal className="mt-3 rounded-2xl border-4 border-dashed border-coral bg-surface p-3 text-ink" data-id="element-62" data-mp="2m4x9sh4sn4or">
          <p className="font-display text-sm font-extrabold uppercase leading-tight text-primary" data-id="element-63" data-mp="2qzkpbqhtkor7">
            {PRODUCT_NAME}
          </p>
          <p className="mt-0.5 font-display text-2xl font-extrabold leading-none" data-id="element-64" data-mp="301tzgf96eg42">
            6 Tomos + 5 Bonos
          </p>
          <p className="mt-1 text-xs font-semibold text-muted sm:text-sm" data-id="element-65" data-mp="34tu58obxg38k">
            Valor de los bonos:{' '}
            <span className="line-through decoration-2" data-id="element-66" data-mp="39rn8b8hxoh4m">{BONUS_TOTAL}</span>
          </p>
          <p className="mt-1 font-display text-5xl font-black leading-none text-coral sm:text-6xl" data-id="element-67" data-mp="3et2x9bn8f7sa">
            <span className="text-2xl text-ink sm:text-3xl" data-id="element-68" data-mp="3itmpq1wv1n83">Hoy:</span>{' '}
            {PRICE}
          </p>

          <CtaButton href={OFFER_ANCHOR} size="lg" className="mt-3" data-id="element-69" data-mp="1jolba6xtm789">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2.5 text-xs font-semibold text-muted" data-id="element-70" data-mp="1sgew45kdu43n">
            Acceso Inmediato • Entrega Digital • Garantía de 7 Días
          </p>
        </Reveal>
      </div>
    </section>;
}